module.exports = __webpack_public_path__ + "images/lpage-career-tracks-2.png";